var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('facebook-sign-in-button',{on:{"sign-in":_vm.facebookSignIn}},[_c('span',[_vm._v("Log in with Facebook")])])}
var staticRenderFns = []

export { render, staticRenderFns }